import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";
import React from "react";
import { useNavigate } from "react-router-dom";
import FileIcon from "~/components/file-type-icon";
import { downloadFileHandler, openPreviewInNewTab } from "~/utils/fileUtils";

const getFilenameFromReference = (fileReference) => {
  if (!fileReference) return "";
  try {
    const url = new URL(fileReference);
    const pathname = url.pathname;
    const filename = pathname.substring(pathname.lastIndexOf("/") + 1);
    return decodeURIComponent(filename);
  } catch (error) {
    console.error("Error extracting filename from reference:", error);
    return "";
  }
};

const PayslipApproveListTable = ({ loading, data, employeesData }) => {
  const skeletonRows = [...Array(5)];
  const getEmployeename = (data) => {
    const employee = employeesData.filter((emp) => {
      return (
        emp?.employee_identifier === data?.extracted_data?.employee_id || ""
      );
    });
    return employee[0] ? employee[0]?.name + employee[0]?.other_name : "";
  };
  return (
    <DataTable
      value={loading ? skeletonRows : data}
      className="datatable-right-align"
      emptyMessage="No result found"
    >
      <Column
        header="Name"
        body={(rowData) => {
          if (loading) {
            return <Skeleton />;
          }
          return (
            <div className="flex align-items-center">
              <FileIcon
                filetype={"application/pdf"}
                filename={""}
                downloadFile={() => {}}
              />
              <span
                className="link-item underline cursor-pointer"
                onClick={() => {
                  openPreviewInNewTab({
                    objectURL: rowData?.file_reference,
                  });
                }}
              >
                {getFilenameFromReference(rowData?.file_reference)}
              </span>
            </div>
          );
        }}
      />
      <Column
        header="Employee"
        body={(field) => (loading ? <Skeleton /> : getEmployeename(field))}
      />
      <Column
        body={(rowData) =>
          loading ? (
            <Skeleton />
          ) : (
            <>
              <i
                className="pi pi-download cursor-pointer mr-2"
                onClick={() =>
                  downloadFileHandler({
                    blob_url: rowData?.file_reference,
                    name: rowData?.extracted_data?.original_filename,
                  })
                }
              />
            </>
          )
        }
      />
    </DataTable>
  );
};

export default PayslipApproveListTable;
